import { takeEvery, put, call } from "redux-saga/effects"
import {
  CLOSE_GET_STARTED_SECTION,
  GET_LIST_OF_APPS,
  GET_PLAN_SPECIFICATION_DETAILS,
  GET_TRANSACTION_LIMIT
} from "./actionTypes"
import {
  setGetStartedSection,
  setListOfApps,
  setPlanSpecificationDetails,
  setTransactionLimit,

} from "./actions"
import {
  LystfaceAppsList,
  LystfaceGetStartedSection,
  LystfaceGetTransactionLimit,
  LystfacePlanSpecificationDetails,
} from "../../../helpers/lystface_helper"
import axios from "axios"

function* watchForGetListOfApps() {
  try {
    const AppsList = yield call(LystfaceAppsList)
    if (AppsList.responseCode == true) {
      yield put(setListOfApps(AppsList))
    } else {
      yield put(setListOfApps(AppsList))

    }
  } catch (error) {
    console.log(error)
    yield put(setListOfApps({ responseMessage: "Error in Fetching Apps List,Please Try Again..", responseStatus: 'Error' }))

  }
}
function* watchForGetPlanSpecificationDetails() {
  try {
    const PlanSpecification = yield call(LystfacePlanSpecificationDetails)
    if (PlanSpecification.responseCode == true) {
      yield put(setPlanSpecificationDetails(PlanSpecification))
    } else {
      yield put(setPlanSpecificationDetails(PlanSpecification))

    }
  } catch (error) {
    console.log(error)
    yield put(setPlanSpecificationDetails({ responseMessage: "Error in Fetching Plan Details,Please Try Again..", responseStatus: 'Error' }))

  }
}

function* watchForCloseGetStartedSectionSaga({ payload }) {
  let Response;
  try {
    Response = yield call(LystfaceGetStartedSection, payload)
    if (Response?.responseCode) {
      yield put(setGetStartedSection({ check: true }))
    }
    else {
      yield put(setGetStartedSection({ check: false }))
    }
  } catch (e) {
    yield put(setGetStartedSection({ responseMessage: 'There was an error closing get started section, please try again later!', check: false }))
  }
}
function* watchForGetTransactionLimit() {
  let Response;
  try {
    Response = yield call(LystfaceGetTransactionLimit)
    if (Response?.responseCode) {
      yield put(setTransactionLimit(Response))
    }
    else {
      yield put(setTransactionLimit(Response))
    }
  } catch (e) {
    yield put(setTransactionLimit({ responseMessage: 'There was an error fetching transaction limit, please try again later!', check: false }))
  }
}

function* HomeMenuSaga() {
  yield takeEvery(GET_LIST_OF_APPS, watchForGetListOfApps)
  yield takeEvery(GET_PLAN_SPECIFICATION_DETAILS, watchForGetPlanSpecificationDetails)
  yield takeEvery(CLOSE_GET_STARTED_SECTION, watchForCloseGetStartedSectionSaga)
  yield takeEvery(GET_TRANSACTION_LIMIT, watchForGetTransactionLimit)


}

export default HomeMenuSaga
